<section class="mat-typography main-heading center">
  <br />
  <h1>Relay Transactions Summary Report</h1>
</section>
@if (!loading) {
<div class="form-group padded-side-nav">
  @if (!resetHeader) {
<app-generic-table-header
   
    [config]="headerOptions"
    (viewPressed)="EnquireReportInfo()"
    (clearPressed)="reset()"
    (exportPressed)="downloadReport()"
    (dropdownSelected)="groupSelect($event)"
    (startDateTimeChange)="setStart($event)"
    (endDateTimeChange)="setEnd($event)"></app-generic-table-header>
}
  @if (!resetHeader) {
<div class="instructions mat-typography">
    Select a date/time range and group to begin report generation.
  </div>
}
  <br />
  <br />
  @if (!loading && reportResults != null && reportResults.length > 0) {
<div
    class="table">
    <div class="heading mat-typography">
      Results
    </div>
    <app-card-table
      [data]="reportResults"
      [tableHeaders]="conditionalHeader"
      [options]="options"
      [enableInfiteScroll]="false"
      [enableTablePagination]="true"
      [enableRefresher]="false"
      [totalItems]="reportResults.length"
      [currentPage]="currentPage"
      (paginateEvent)="onPageChange($event)"
      [breakpoint]="ScreenSize.TABLET">
    </app-card-table>
  </div>
}
</div>
}
@if (loading) {
<div class="flex-center">
  <mat-spinner></mat-spinner>
</div>
}